import Service from "../Service";
const resource = "/TasGroupZon/";

export default {
  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID },
    });
  },
  pagination(obj, requestID) {
    return Service.post(resource + "pagination", obj, {
      params: { requestID },
    });
  },
  GetZonesByGroup(obj, requestID) {
    return Service.post(resource + "GetZonesByGroup", obj, {
      params: { requestID },
    });
  },
};
